<template lang="pug">

  .hero(:style="heroStyles")
   <slot name="top-content"></slot>
   .hero__carousel(
    :is="slides.length > 1 ? 'VueSlickCarousel' : 'div'"
    v-bind="sliderSettings"
    dots
    )
      a.hero__slide(
        v-for="slide, index in slides"
        :key="`hero_${_uid}_slide${index}`"
        :class="{ 'hero__slide--content-below': slide.content_below}"
        :href="slide.link"
      )
        img.hero__image(
          :src="['desktop', 'hd'].includes($mq) ? slide.background_image : slide.mobile_background_image"
          :alt="slide.background_image_alt"
        )

</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel';

  export default {
    name: 'Hero',
    components: {
      VueSlickCarousel,
    },
    props: {
      margin: String,
      padding: String,
      slides: {
        type: Array,
        default: () => [
          {
            background_image: String,
            mobile_background_image: String,
            background_image_alt: String,
            link: String,
          },
        ],
      },
    },
    data() {
      return {
        sliderSettings: {
          arrows: false,
          dots: true,
          dotsClass: 'slick-dots hero__dots',
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 8000,
        },
      };
    },
    computed: {
      heroStyles() {
        return {
          'margin-bottom': `${this.margin}px`,
          padding: `${this.padding}px ${this.padding}px 0`,
        };
      },
    },
    methods: {},
  };
</script>
<style lang="scss">
  .hero {
    position: relative;
    z-index: index($layout, 'page-layout-content');
    margin-bottom: 30px;
  }

  .hero__carousel {
    overflow: hidden;
  }

  .hero__slide {
    display: block !important;
    position: relative;
    padding: 0;
    overflow: hidden;

    @include desktop-up {
      background-position: center;
    }
  }

  .hero__dots {
    bottom: 20px;

    @include desktop-up {
      bottom: 20px;
    }
  }

  .hero__image {
    display: block;
    width: 100%;
  }
</style>
